import { render, staticRenderFns } from "./EncartFb.vue?vue&type=template&id=2e5c87e0&"
import script from "./EncartFb.vue?vue&type=script&lang=js&"
export * from "./EncartFb.vue?vue&type=script&lang=js&"
import style0 from "./EncartFb.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports